import { render, staticRenderFns } from "./ResInfoCard.vue?vue&type=template&id=40128d05&scoped=true&lang=pug"
import script from "./ResInfoCard.vue?vue&type=script&lang=js"
export * from "./ResInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ResInfoCard.vue?vue&type=style&index=0&id=40128d05&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40128d05",
  null
  
)

export default component.exports